import moment from 'moment/moment'
import { setCurrency, setNumberWithPoint } from 'utils/utils'
import { Link } from 'react-router-dom'

export const CARD_ORDER_COMPARISON = [
    {
        title: 'Total Sales',
        name: 'total_sales',
        isCurrency: true,
    },
    {
        title: 'Rata-Rata Item Per Order',
        name: 'average_item_per_order',
        isCurrency: false,
    },
    {
        title: 'Total Order',
        name: 'total_order',
        isCurrency: false,
    },
    {
        title: 'Nilai Rata-Rata Per Order',
        name: 'average_value_per_order',
        isCurrency: true,
    },
]

export const TABLE_ORDER = {
    name: 'Order',
    column: [
        {
            name: 'Tanggal',
            key: 'formatted_date',
        },
        {
            name: 'Nomor Order',
            key: 'order_code',
            render: ({ item }) => (
                <Link
                    to={`/order/order-list/detail?orderId=${item?.id}`}
                    className={'font-medium text-blue-90 hover:font-bold hover:underline'}
                >
                    {item?.order_code}
                </Link>
            ),
        },
        {
            name: 'Status Order',
            key: 'status',
            className: 'capitalize',
        },
        {
            name: 'Customer',
            key: 'customer',
            className: 'capitalize',
            render: ({ value }) => <div className={value === 'new' ? 'text-[#5288B9]' : 'text-[#8168C9]'}>{value}</div>,
        },
        {
            name: 'Product',
            key: 'product',
        },
        {
            name: 'Item Sold',
            key: 'quantity',
            render: ({ value }) => <div>{value ? setNumberWithPoint(value) : '-'}</div>,
        },
        {
            name: 'Voucher Code',
            key: 'vouchers',
        },
        {
            name: 'Total Sales',
            key: 'total_sales',
            render: ({ value }) => <div>{setCurrency(value)}</div>,
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
    start_date: moment().format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
}

export const INITIAL_ADVANCE_FILTER = {
    voucher_codes: [],
    payment_services: [],
    shipping_aliases: [],
}

export const FILTER_PARAMS = ['voucher_codes', 'payment_services', 'shipping_aliases']
